import { AALocationModel } from '../../route-planner/models/route-model';
import { TrafficAlertType } from '../../google-map/enums/google-map-enum';

export class TrafficNewsOption {
    name: string;
    value: boolean;
    type: TrafficAlertType;
    imageLogoPath: string;

    constructor(type, name, imageLogPath, value?: boolean) {
        this.type = type;
        this.name = name;
        this.imageLogoPath = imageLogPath;
        this.value = value;
    }
}

export class TrafficNewsModel {

    locationModel: AALocationModel;
    trafficOptionsData: Array<TrafficNewsOption> = [];

    constructor() {
        this.locationModel = new AALocationModel('');

        this.trafficOptionsData.push(
            new TrafficNewsOption(TrafficAlertType.INCIDENTS, 'Incidents', './assets/icons/svg/icon-incidents.svg', true),
            new TrafficNewsOption(TrafficAlertType.ROADWORKS, 'Roadworks', './assets/icons/svg/icon-roadworks.svg', true),
            new TrafficNewsOption(TrafficAlertType.CONGESTION, 'Congestion', './assets/icons/svg/icon-congestion.svg', true),
            new TrafficNewsOption(TrafficAlertType.ROAD_CLOSURES, 'Road closures', './assets/icons/svg/icon-road-closure.svg', true),
            new TrafficNewsOption(TrafficAlertType.LANE_CLOSED, 'Lane closed', './assets/icons/svg/icon-lane-closed.svg', true),
            new TrafficNewsOption(TrafficAlertType.WEATHER_INCIDENTS,
                'Weather incidents', './assets/icons/svg/icon-weather-incidents.svg', true),
        );
    }
}


